/* Product page accordion: clicking an already-open tab closes it (theme only opens). */
document.addEventListener('click', function (e) {
  var head = e.target.closest && e.target.closest('.prTabs .acor-ttl');
  if (!head) return;
  var link = head.querySelector('.tablink');
  var panel = link && document.querySelector(link.getAttribute('href'));
  if (!panel || !head.classList.contains('active') || panel.offsetHeight === 0) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  head.classList.remove('active');
  if (window.jQuery) { window.jQuery(panel).stop(true, true).slideUp(250); } else { panel.style.display = 'none'; }
}, true);
